module.exports = __webpack_public_path__ + "img/quest-pink.b80c4ffc.svg";